/* @flow */
import * as React from 'react';

// Styles
import styles from './FormikAutocomplete.style';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

// Components

import MagnifierIcon from 'src/shared/ui/component/icon/MagnifierIcon';
import {
  Autocomplete,
  CircularProgress,
  InputAdornment,
  TextField,
} from '@mui/material';

const useStyles = createUseThemeStyles(styles);

type Props = {
  field: Object,
  options?: Object[],
  onChange: (value: Object) => void,
  startAdornment: (value: Object) => React.Node,
  getOptionLabel: (value: Object) => string,
  onInputChange: (event: Object, value: string) => string,
  renderOption: (props: Object, value: Object) => React.Node,
  isOptionEqualToValue: (option: Object, value: Object) => Boolean,
  isFetching?: boolean,
  form: Object,
  disabled?: boolean,
  isFetching?: boolean,
  readOnly?: boolean,
};

const FormikAutocomplete = ({
  field,
  form,
  isFetching,
  readOnly,
  disabled,
  options,
  onInputChange,
  startAdornment,
  getOptionLabel,
  renderOption,
  isOptionEqualToValue,
}: Props): React.Node => {
  const classes = useStyles();

  return (
    <Autocomplete
      {...field}
      className={classes.root}
      classes={classes}
      options={options}
      renderOption={renderOption}
      onChange={(_, value) => form.setFieldValue(field.name, value)}
      value={field.value || null}
      loading={isFetching}
      getOptionLabel={getOptionLabel}
      isOptionEqualToValue={isOptionEqualToValue}
      onInputChange={onInputChange}
      renderInput={(params) => (
        <TextField
          {...params}
          disabled={disabled || isFetching}
          readOnly={readOnly}
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <InputAdornment position="start">
                {field.value && startAdornment ? (
                  startAdornment(field.value)
                ) : (
                  <MagnifierIcon className={classes.startAdornment} />
                )}
              </InputAdornment>
            ),
            endAdornment: (
              <React.Fragment>
                {isFetching ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
};

export default React.memo<Props>(FormikAutocomplete);
